import { getWeekdaysCount } from "helper/billable-project/utils";
import moment from "moment";
import { getWorkingHoursPerDay, getWorkingHoursPerWeek } from "./allocation.service";
import { setDecimalPrecision } from "helper/util";

const getWeeksInMonth = ({ year, month, demandStartDate, demandEndDate }) => {
    const weeks = [];
    let startDate = moment().year(year).month(month).startOf('month');
    // startDate = startDate.isSameOrAfter(moment(demandStartDate)) ? startDate : moment(demandStartDate);
    let endDate = moment().year(year).month(month).endOf('month');
    // endDate = endDate.isSameOrBefore(moment(demandEndDate)) ? endDate : moment(demandEndDate);
    const currentWeekStart = startDate.clone().startOf('week');
    while (currentWeekStart.isSameOrBefore(endDate)) {
        let currentWeekEnd = currentWeekStart.clone().endOf('week');
        currentWeekEnd = currentWeekEnd.month() === endDate.month() ? currentWeekEnd : endDate;
        currentWeekEnd = currentWeekEnd.isSameOrBefore(moment(demandEndDate)) ? currentWeekEnd : moment(demandEndDate);
        const isWeekStartDateInSameMonth = currentWeekStart.month() === startDate.month();
        let countStartDate = isWeekStartDateInSameMonth ? currentWeekStart : startDate;
        countStartDate = countStartDate.isBefore(moment(demandStartDate)) ? moment(demandStartDate) : countStartDate;
        const numberOfWorkingDays = getWeekdaysCount(countStartDate, currentWeekEnd);
        const isDisabled = !numberOfWorkingDays;

        weeks.push({
            startDate: currentWeekStart.clone().format('MM-DD-YYYY'),
            endDate: currentWeekEnd.clone().format('MM-DD-YYYY'),
            numberOfWorkingDays,
            isDisabled
        });
        currentWeekStart.add(1, 'week');
    }
    return weeks;
};

export function distributeHours({ hours, year, month, demandStartDate, demandEndDate, hoursPerWeek }) {
    const weeks = getWeeksInMonth({ year, month, demandStartDate, demandEndDate });
    const maxHoursPerWeek = hoursPerWeek ?? getWorkingHoursPerWeek();
    let maxHoursPerDay = getWorkingHoursPerDay();
    if (hoursPerWeek) {
        const workingDays = getWeekdaysCount(demandStartDate, demandEndDate);
        maxHoursPerDay = workingDays >= 5 ? hoursPerWeek / 5 : hoursPerWeek / workingDays;
    }

    let remainingHours = hours;
    const weeksData = weeks.map((week) => {
        const { isDisabled, numberOfWorkingDays, startDate, endDate } = week;
        const hoursInAWeek = (numberOfWorkingDays * maxHoursPerDay);
        const value = remainingHours >= hoursInAWeek ? Math.min(hoursInAWeek, maxHoursPerWeek) : remainingHours;

        const weekHourValue = remainingHours > 0 ? value : 0;
        remainingHours -= value;
        return {
            isDisabled,
            numberOfWorkingDays,
            value: setDecimalPrecision(weekHourValue),
            startDate,
            endDate
        };
    });

    return weeksData;
}

export const getTimeLineData = ({ demandStartDate, demandEndDate, totalhours, existingTimeLines = [], hoursPerWeek, forceUseExisting = false }) => {
    const monthlist = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    const currentyear = `${moment().year()}`;
    let remainingHours = totalhours;
    const timelineMap = existingTimeLines.map((el) => {
        const year = `${el.year}`.length === 2 ? `${currentyear.slice(0, 2)}${el.year}` : `${el.year}`;
        return { ...el, year };
    }).reduce((acc, timeline) => {
        monthlist.forEach((m, index) => {
            const month = moment().month(m).format('MMMM');
            if(timeline[m] === undefined){
                return;
            }

            const effectiveYear = index <= 4
                    ? Number(timeline.year)
                    : Number(timeline.year) - 1;

            const weeksData = forceUseExisting && timeline.monthWeeksData && timeline.monthWeeksData[m] ? timeline.monthWeeksData[m] : distributeHours({
                hours: timeline[m],
                year: `${effectiveYear}`,
                month,
                demandStartDate,
                demandEndDate,
                hoursPerWeek
            });
            const hrs = setDecimalPrecision(weeksData?.reduce((acc, wd) => acc + wd.value, 0));
            remainingHours = setDecimalPrecision(remainingHours - timeline[m]);
            acc[`${month}-${effectiveYear}`] = {
                id: timeline.id, 
                quotelineId: timeline.quotelineId,
                demandId: timeline.demandId,
                year: `${effectiveYear}`,
                month,
                weeksData,
                hours: hrs,//timeline.hours,
                updatedHours: timeline[m]
            };
        });
        return acc;
    }, {});
    const startDate = moment(demandStartDate);
    const timelines = [];
    const mDemandEndDate = moment(demandEndDate).endOf('month');

    const getDataForMonth = ({ year, month }) => {
        const weeksData = distributeHours({
            hours: remainingHours, year, month, demandStartDate, demandEndDate, hoursPerWeek
        });
        const hours = setDecimalPrecision(weeksData.reduce((acc, el) => acc + el.value, 0));
        timelines.push({
            year: `${year}`,
            month,
            hours,
            weeksData
        });
    };

    while (startDate.isBefore(mDemandEndDate)) {
        const currentMonth = startDate.format('MMMM');
        const currentYear = startDate.year();
        const prevTimeline = timelineMap[`${currentMonth}-${currentYear}`];
        // console.log("🚀 ~ getTimeLineData ~ currentYear:", {currentYear,currentMonth , prevTimeline})

        if (prevTimeline) {
            timelines.push(prevTimeline);
        } else {
            getDataForMonth({ year: currentYear, month: currentMonth });
        }

        startDate.add(1, 'month');
    }

    return timelines;
};

export const gettimelineDateChangeAvailability = ({ timeline = [], formData }) => {
    const sortedTimelines = Array.from(timeline).sort((a, b) => {
        if (a.year - b.year === 0) {
            const timelineMonth1 = moment().month(a.month).month();
            const timelineMonth2 = moment().month(b.month).month();

            return (timelineMonth1 - timelineMonth2);
        }
        return (a.year - b.year);
    });
    const firstTimeline = sortedTimelines.find((tl) => (tl.hours ?? tl.totalHours));
    const lastTimeline = Array.from(sortedTimelines).reverse().find((tl) => (tl.hours || tl.totalHours));

    const timelineInitialDate = firstTimeline
        ? moment().startOf('month').month(firstTimeline.month).year(firstTimeline.year) : null;

    const timelineEndDate = lastTimeline
        ? moment().endOf('month').month(lastTimeline.month).year(lastTimeline.year) : null;

    const isStartDateAfterTimeline = firstTimeline
        ? timelineInitialDate.isBefore(moment(formData))
        : false;

    const isEndDateBeforeTimeline = lastTimeline
        ? timelineEndDate.isAfter(moment(formData))
        : false;
    return { isStartDateAfterTimeline, isEndDateBeforeTimeline };
}

export const getMonthWiseTimeLineData = (timelines) => {
    const months = ['jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec', 'jan', 'feb', 'mar', 'apr', 'may'];
    return timelines.flatMap((timeline) =>
        months.filter((monthKey) => timeline[monthKey] !== null ).map((monthKey) => {
            const month = moment().month(monthKey).format('MMMM');
            const weeksData = timeline.monthWeeksData && timeline.monthWeeksData[monthKey];
            const hrs = weeksData ? setDecimalPrecision(weeksData?.reduce((acc, wd) => acc + wd.value, 0)) : 0;
            const effectiveYear = ['jan', 'feb', 'mar', 'apr', 'may'].includes(monthKey)
                    ? Number(timeline.year)
                    : Number(timeline.year) - 1;

            return {
                id: timeline.id,
                demandId: timeline.demandId,
                year: `${effectiveYear}`,
                month,
                hours: hrs || timeline[monthKey] || 0,
                weeksData: weeksData,
                originalValue: timeline.originalValues && timeline.originalValues[monthKey]
            };
        })
    )
    .sort((a, b) => {
        const dateA = moment(`${a.year}-${a.month}`, 'YYYY-MMMM');
        const dateB = moment(`${b.year}-${b.month}`, 'YYYY-MMMM');

        return dateA.valueOf() - dateB.valueOf();
    });
}

export const getTimelineinDbFormat = (timelines) => {
    const data = timelines.reduce((acc, timeline) => {
        const monthIndex = moment(timeline.month, 'MMMM').month();
        const effectiveYear =  monthIndex <= 4
            ? Number(timeline.year)
            : Number(timeline.year) + 1;
        const year = `${effectiveYear}`;

        if(!acc[year]){
            acc[year] = {
                year: year,
                ...( timeline.demandId ? { demandId : timeline.demandId } : {}),
                ...( timeline.id ? { id : timeline.id } : {}),
            };
        }
        const month = moment(timeline.month, 'MMMM').format('MMM').toLowerCase();
        
        if(!acc[year][month]){
            acc[year][month] = !timeline.id ? (timeline?.updatedHours ? timeline?.updatedHours : timeline?.hours) : timeline.totalHours;
            if(!acc[year].monthWeeksData) {
                acc[year].monthWeeksData = {};
            }
            acc[year].monthWeeksData[month] = timeline.weeksData;
        }

        return acc;
    }, {});

    return Object.values(data);
}